import React, { useState, useEffect, Fragment, useRef } from "react";
import "./SideNavigation.scss";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faUserGear,
  faGear,
  faUpload,
  faShareNodes,
  faPersonShelter,
  faHotel,
  faHatWizard,
  faHandshake,
  faImage,
  faBellConcierge,
  faDesktopAlt,
  faImages,
  faDoorOpen,
  faPeopleGroup,
  faCity,
  faMobileAndroidAlt,
  faMessage,
  faListCheck,
  faSheetPlastic,
  faArrowsRotate,
  faTableColumns
} from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { MdOutlineContentPasteSearch } from "react-icons/md";
import {
  canAccessRoute,
  canAccessMenuGroup,
} from "../../../routes/routePermissions";

function SideNavigation() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isActive, setIsActive] = useState(location?.pathname);
  const [collapseEnter, setCollapseEnter] = useState(false);
  const [collapseLeave, setCollapseLeave] = useState(false);
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  const { viewType } = useSelector((state) => state.viewTypeReducer);

  // Keep localStorage viewType in sync for route loaders / canAccessRoute.
  if (viewType != null && viewType !== "") {
    localStorage.setItem("viewType", viewType);
  }

  useEffect(() => {
    setIsActive(location.pathname);
  }, [location]);

  const sideBarNavigations = [
    {
      label: "Dashboard",
      icon: faTableColumns,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: canAccessMenuGroup("dashboard"),
      childMenu: [
        {
          subLabel: "Hotels Dashboard",
          to: "/hms/Dashboard/Hotels_Dashboard",
          permissionAvailable: canAccessRoute("/hms/Dashboard/Hotels_Dashboard"),
        },
        {
          subLabel: "Automode Dashboard",
          to: "/hms/Dashboard/Automode_Dashboard",
          permissionAvailable: canAccessRoute("/hms/Dashboard/Automode_Dashboard"),
        },
        {
          subLabel: "APK Version Dashboard",
          to: "/hms/Dashboard/APK_Version_Dashboard",
          permissionAvailable: canAccessRoute("/hms/Dashboard/APK_Version_Dashboard"),
        },
        {
          subLabel: "Asset Management Dashboard",
          to: "/hms/Dashboard/AssetManagement_Dashboard",
          permissionAvailable: canAccessRoute("/hms/Dashboard/AssetManagement_Dashboard"),
        },
        {
          subLabel: "Test/Demo Hotels Dashboard",
          to: "/hms/Dashboard/Test_Demo_Hotels_Dashboard",
          permissionAvailable: canAccessRoute("/hms/Dashboard/Test_Demo_Hotels_Dashboard"),
        },
      ]
    },
    {
      label: "Hotel Configuration",
      icon: faHotel,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationNewHotel",
      permissionAvailable: canAccessRoute("/hms/ConfigurationNewHotel"),
    },
    {
      label: "Hotel Onboarding Wizard",
      icon: faHatWizard,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelOnboardingWizard",
      permissionAvailable: canAccessRoute("/hms/HotelOnboardingWizard"),
    },
    {
      label: "Master APK Configuration",
      icon: faMobileAndroidAlt,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationMasterApk",
      permissionAvailable: canAccessRoute("/hms/ConfigurationMasterApk"),
    },
    {
      label: "Room Configuration",
      icon: faPersonShelter,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationNewRoom",
      permissionAvailable: canAccessRoute("/hms/ConfigurationNewRoom"),
    },
    {
      label: "Welcome Screen Config",
      icon: faDoorOpen,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/WelcomeScreenConfig",
      permissionAvailable: canAccessRoute("/hms/WelcomeScreenConfig"),
    },
    {
      label: "Welcome Message",
      icon: faUpload,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/WelcomeMessages",
      permissionAvailable: canAccessRoute("/hms/WelcomeMessages"),
    },
    {
      label: "Hero Banner",
      icon: faGear,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HeroBanner",
      permissionAvailable: canAccessRoute("/hms/HeroBanner"),
    },
    
    {
      label: "Rail Configuration",
      icon: faImage,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/RailConfiguration",
      permissionAvailable: canAccessRoute("/hms/RailConfiguration"),
    },
    {
      label: "Hotel Services",
      icon: faBellConcierge,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelServiceConfiguration",
      permissionAvailable: canAccessRoute("/hms/HotelServiceConfiguration"),
    },
    {
      label: "Hotel Channels",
      icon: faShareNodes,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelChannels",
      permissionAvailable: canAccessRoute("/hms/HotelChannels"),
    },
    {
      label: "Screensaver",
      icon: faDesktopAlt,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ScreensaverConfiguration",
      permissionAvailable: canAccessRoute("/hms/ScreensaverConfiguration"),
    },
    {
      label: "Background Image",
      icon: faImages,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationBackgroundImage",
      permissionAvailable: canAccessRoute("/hms/ConfigurationBackgroundImage"),
    },
    {
      label: "City Configuration",
      icon: faCity,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/cityConfiguration",
      permissionAvailable: canAccessRoute("/hms/cityConfiguration"),
    },
    {
      label: "Group Rooms",
      icon: faPeopleGroup,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/GroupRooms",
      permissionAvailable: canAccessRoute("/hms/GroupRooms"),
    },
    {
      label: "CDSN Level Configurations",
      icon: '',
      iconType: "reactIcon",
      subMenu: false,
      to: "/hms/fetchcdsndetails",
      permissionAvailable: canAccessRoute("/hms/fetchcdsndetails"),
    },
    {
      label: "SID-CDSN Details",
      icon: faListCheck,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/fetchcdsndetailsAdmin",
      permissionAvailable: canAccessRoute("/hms/fetchcdsndetailsAdmin"),
    },
    {
      label: "Auto Mode Report",
      icon: faSheetPlastic,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/autoModeReport",
      permissionAvailable: canAccessRoute("/hms/autoModeReport"),
    },
    {
      label: "Re-Sync Chain ID",
      icon: faArrowsRotate,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/resyncchainid",
      permissionAvailable: canAccessRoute("/hms/resyncchainid"),
    },
    {
      label: "Activity Logs",
      icon: faMessage,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/activityLogs",
      permissionAvailable: canAccessRoute("/hms/activityLogs"),
    },
    {
      label: "Master Configurations",
      icon: faHandshake,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: canAccessMenuGroup("masterConfigurations"),
      childMenu: [
        {
          subLabel: "Default Config",
          to: "/hms/DefaultConfig",
          permissionAvailable: canAccessRoute("/hms/DefaultConfig"),
        },
        {
          subLabel: "Whitelist Domain",
          to: "/hms/WhitelistDomain",
          permissionAvailable: canAccessRoute("/hms/WhitelistDomain"),
        },
        {
          subLabel: "OTT Apps",
          to: "/hms/PartnerConfiguration",
          permissionAvailable: canAccessRoute("/hms/PartnerConfiguration"),
        },
        {
          subLabel: "Room Type",
          to: "/hms/RoomTypeConfiguration",
          permissionAvailable: canAccessRoute("/hms/RoomTypeConfiguration"),
        },
        {
          subLabel: "APK Provider Configuration",
          to: "/hms/APKProviderConfiguration",
          permissionAvailable: canAccessRoute("/hms/APKProviderConfiguration"),
        },
        {
          subLabel: "Third Party Hotel Configuration",
          to: "/hms/thirdPartyHotelConfiguration",
          permissionAvailable: canAccessRoute("/hms/thirdPartyHotelConfiguration"),
        },
        {
          subLabel: "Utilities",
          to: "/hms/UtilityServiceConfiguration",
          permissionAvailable: canAccessRoute("/hms/UtilityServiceConfiguration"),
        },
        {
          subLabel: "Satellite Channel Mapping",
          to: "/hms/SatelliteChannelMapping",
          permissionAvailable: canAccessRoute("/hms/SatelliteChannelMapping"),
        },
        {
          subLabel: "Software Stack Details",
          to: "/hms/SoftwareStackDetails",
          permissionAvailable: canAccessRoute("/hms/SoftwareStackDetails"),
        }
      ],
    },
    {
      label: "User Management",
      icon: faUserGear,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: canAccessMenuGroup("userManagement"),
      childMenu: [
        {
          subLabel: "Users",
          to: "/hms/userList",
          permissionAvailable: canAccessRoute("/hms/userList"),
        },
        {
          subLabel: "Create User",
          to: "/hms/createEditUser",
          permissionAvailable: canAccessRoute("/hms/createEditUser"),
        },
        {
          subLabel: "Roles",
          to: "/hms/roles",
          permissionAvailable: canAccessRoute("/hms/roles"),
        },
        {
          subLabel: "Roles And Permissions",
          to: "/hms/rolesPermissions",
          permissionAvailable: canAccessRoute("/hms/rolesPermissions"),
        },
        {
          subLabel: "User Privileges",
          to: "/hms/userPrivilege",
          permissionAvailable: canAccessRoute("/hms/userPrivilege"),
        },
      ],
    },
  ];

  const toggleDropdown = (index) => {
    // setIsOpen(!isOpen);
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
  };

  const closeSubMenu = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const hoverTimeout = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current); // cancel any pending collapse
    closeSubMenu();
    setShowMenu(true);
    setCollapseEnter(true);
    setCollapseLeave(false);
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      closeSubMenu();
      setShowMenu(false);
      setCollapseEnter(false);
      setCollapseLeave(true);
    }, 150); // delay prevents accidental rapid toggle
  };


  return (
    <div
      className={`sideNav ${collapseEnter ? 'show-menu-hover' : ''} ${collapseLeave ? 'show-menu-collapse' : ''}`}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      <div className="sideNav-items">
        {sideBarNavigations?.map((data, index) => (
          <Fragment>
            {data?.permissionAvailable ? (
              <div key={index} className="side-menu-items">
                <div className="side-menu">
                  <div className="menu-links">
                    {data.subMenu ? (
                      <div>
                        <div
                          className="sub-menu sidenav-inactive"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FontAwesomeIcon
                            icon={data?.icon}
                            onMouseEnter={() => setShowMenu(true)}
                          />
                          {showMenu && (
                            <span className="menu-item">
                              <h5>{data.label}</h5>
                              {openSubmenuIndex === index ? (
                                <span className="menu_up_arrow">
                                  <FontAwesomeIcon icon={faAngleUp} />
                                </span>
                              ) : (
                                <span className="menu_down_arrow">
                                  <FontAwesomeIcon icon={faAngleDown} />
                                </span>
                              )}
                            </span>
                          )}
                        </div>

                        {openSubmenuIndex === index && showMenu && (
                          <div className="menu_options_open">
                            <span className="menu_options">
                              {data?.childMenu?.map((child, childIndex) => {
                                return (
                                  <Fragment>
                                    {child?.permissionAvailable ? (
                                      <div
                                        key={childIndex}
                                        className={`sub_menu ${isActive === child.to
                                          ? "sidenav-active"
                                          : "sidenav-inactive"
                                          } `}
                                      >
                                        <Link to={child.to} >
                                          <h5>{child?.subLabel}</h5>
                                        </Link>
                                      </div>
                                    ) : null}
                                  </Fragment>
                                );
                              })}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <Link
                        to={data.to}
                        className={`main-menu ${isActive === data.to
                          ? "sidenav-active"
                          : "sidenav-inactive"
                          } `}
                      // onClick={(e) => {
                      //   if (hotelChainId === null && userRoleCode !== "ROLE_SUPER_ADMIN") {
                      //     e.preventDefault();
                      //   }
                      // }}
                      >
                        {data?.iconType === "reactIcon" ? <MdOutlineContentPasteSearch className="cdsn-detail-icon" onMouseEnter={() => setShowMenu(true)} />
                          : <FontAwesomeIcon
                            icon={data?.icon}
                            onMouseEnter={() => setShowMenu(true)}
                          />}

                        {showMenu && <h5>{data.label}</h5>}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default SideNavigation;
